angular.module('bzValidationModule', [])
